type Props = {
    className?: string;
    columnclasses?: string;
    hasdivider: boolean;
};

const GridColumn = ({
    className,
    columnclasses,
    children,
    hasdivider,
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={[
                'grid-column',
                columnclasses,
                className,
                'mb-6',
                'md:mb-0',
                hasdivider && 'relative',
            ]
                .filter((e) => e)
                .join(' ')}
        >
            <div className="md:flex md:h-full">
                <div className="column-content w-full">{children}</div>
                {hasdivider && (
                    <div className="w-full md:w-auto md:h-full absolute md:top-0 md:-right-3 -bottom-3 border-t md:border-t-0 md:border-r border-gray-dark"></div>
                )}
            </div>
        </div>
    );
};

export default GridColumn;
